export default __webpack_public_path__ + "static/media/zylb.8ff26d39.jpg";